import { FormattedMessage } from 'react-intl';

import { Box, BoxProps, useTheme } from '@mui/material';

import { MetricMeasurementBar } from '../../../MetricMeasurementBar';

export interface LeverageContentProps extends BoxProps {
  debtPercent: number;
}

export const LeverageContent = ({ debtPercent, sx, ...rest }: LeverageContentProps) => {
  const { gradients } = useTheme();
  return (
    <Box
      width={{ xs: '100%', lg: '90%' }}
      sx={{
        '& .debt-percent-indicator': {
          margin: '0 auto',
          width: {
            xs: '90%',
            lg: '100%',
          },
        },
        ...sx,
      }}
      {...rest}
    >
      <MetricMeasurementBar
        background={gradients.sea.horizontal}
        className="debt-percent-indicator"
        lowerBound={0}
        lowerLabel={<FormattedMessage id="lower" defaultMessage="Lower" />}
        metric={debtPercent / 100}
        numberFormatOptions={{ style: 'percent', maximumFractionDigits: 1, minimumFractionDigits: 0 }}
        upperBound={1}
        upperLabel={<FormattedMessage id="higher" defaultMessage="Higher" />}
      />
    </Box>
  );
};
